import axios from "axios";

const apiUrl = "https://converso-social-network-api.onrender.com";

const getToken = () => {
  return localStorage.getItem("token");
};

export const dataProvider = {
  getList: async (resource, params) => {
    try {
      const { page, perPage } = params.pagination;
      const token = getToken();

      const { data } = await axios.get(`${apiUrl}/admin/${resource}`, {
        params: {
          page,
          pageSize: perPage,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (resource === "posts") {
        return {
          data: data.posts,
          total: data.totalPages * perPage,
        };
      } else if (resource === "users") {
        return {
          data: data.users,
          total: data.totalPages * perPage,
        };
      } else if (resource === "chats") {
        return {
          data: data.chats,
          total: data.totalPages * perPage,
        };
      } else if (resource === "comments") {
        return {
          data: data.comments,
          total: data.totalComments,
        };
      } else {
        throw new Error(`Unknown resource: ${resource}`);
      }
    } catch (error) {
      console.error("Error fetching the list:", error);
      throw new Error("Error fetching the list");
    }
  },

  getOne: async (resource, params) => {
    try {
      const { id } = params;
      const token = getToken();

      const { data } = await axios.get(
        `https://converso-social-network-api.onrender.com/admin/${resource}/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (resource === "posts") {
        console.log(data);
        return {
          data: {
            images: data.images,
            id: data.id,
            postMessage: data.postMessage,
            userName: data.userName,
            likes: data.likes,
            comments: data.comments,
          },
        };
      } else {
        throw new Error(`Unknown resource: ${resource}`);
      }
    } catch (error) {
      console.error("Error fetching the post:", error);
      throw new Error("Error fetching the post");
    }
  },

  delete: async (resource, params) => {
    try {
      const { id } = params;
      const token = getToken();

      await axios.delete(`${apiUrl}/admin/${resource}/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return { data: { id } };
    } catch (error) {
      console.error("Error deleting the post:", error);
      throw new Error("Error deleting the post");
    }
  },
};
